module.exports = "/images/Philippines.png?5bcfb9c78bec841eb462aed05be3b831";